module.exports = __webpack_public_path__ + "static/media/capstone_permissions.98153c40.yaml";